import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/book/$bookId")({
  component: lazyRouteComponent(
    () => import("../pages/Book/BookRouteLayout"),
    "BookRouteLayout",
  ),
});
